/**
 * Make all imported dependencies globally available by assign them into window
 */

// jQuery
import jQuery from "jquery";
// window.jQuery = jQuery;
// window.$ = jQuery;

// Bootstrap
// import popper from "popper.js";
// window.popper = popper;
// import * as bootstrap from "bootstrap";
// window.bootstrap = bootstrap;

// Image carousel slider
import SwiperCore, { Navigation, Pagination, Autoplay, Lazy } from 'swiper/core';
SwiperCore.use([Navigation, Pagination, Autoplay, Lazy]);
window.Swiper = SwiperCore;

// Ellipsis multiline text
// https://github.com/xavi160/Clamp.js
import $clamp from "clamp-js";
window.$clamp = $clamp;

// Custom scroll bar
// https://github.com/Grsmto/simplebar/tree/master/packages/simplebar
// import * as SimpleBar from 'simplebar';
// window.SimpleBar = SimpleBar;


// Parallax
// https://github.com/nk-o/jarallax
import { jarallax, jarallaxVideo } from "jarallax";
window.jarallax = jarallax;
$.fn.jarallax = jarallax;
jarallaxVideo();

// Zoom images to full screen
// https://github.com/biati-digital/glightbox
import GLightbox from 'glightbox';
window.GLightbox = GLightbox;